import React, { Component, lazy, Suspense } from "react";
import { Button, Icon, Divider } from "react-materialize";
import "./UserManagementSection.styles.scss";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { changeTo } from "../../../../store/actions/adminTableSelectAction";
import BackOfficeEmpolyeeTable from "../BackOfficeEmpolyeeTable/BackOfficeEmpolyeeTable";

const FSETable = lazy(() => import("../FSETable/FSETable"));
const MDOTable = lazy(() => import("../MDOTable/MDOTable"));

class UserManagementSection extends Component {
  // componentDidMount() {
  //   if (new URLSearchParams(window.location.search).get("tab")) {
  //     const tab = new URLSearchParams(window.location.search).get("tab");
  //     this.props.history.push({ search: `tab=${tab}` });
  //     this.props.changeTableTo(tab);
  //   } else {
  //     this.props.history.push({ search: `tab=user` });
  //   }
  //   // if (!params) params.append("tab", "geo");
  //   // this.props.history.push({ search: params.toString() });
  // }
  // onChangeTab = (tab) => {
  //   const params = new URLSearchParams();
  //   params.append("tab", tab);
  //   this.props.history.push({ search: params.toString() });
  //   this.props.changeTableTo(tab);
  // };
  changeActive = (to) => {
    if (to !== this.state.active_group) {
      this.setState({
        active_group: to,
      });
    }
  };

  render() {
    return (
      <div className="user-management">
        <div className="title-buttons-container">
          <div className="title">
            <h2>User Management</h2>
          </div>

          <div className="buttons-group">
            <Button
              className={`im-btn fse-btn ${
                this.props.active_table === "fse" ? `active` : `inactive`
              }`}
              onClick={() => this.props.changeTo("fse")}
              node="button"
              style={{
                marginRight: "0px",
              }}
              waves="light"
            >
              Supervisor
              {/* <Icon left>person</Icon> */}
            </Button>
            <Button
              className={`im-btn mdo-btn ${
                this.props.active_table === "mdo" ? `active` : `inactive`
              }`}
              onClick={() => this.props.changeTo("mdo")}
              node="button"
              style={{
                marginRight: "0px",
              }}
              waves="light"
            >
              Field force
              {/* <Icon left>people</Icon> */}
            </Button>
            <Button
              className={`im-btn fse-btn ${
                this.props.active_table === "backOffice" ? `active` : `inactive`
              }`}
              onClick={() => this.props.changeTo("backOffice")}
              node="button"
              style={{
                marginRight: "0px",
              }}
              waves="light"
            >
              Office employee
              {/* <Icon left>person</Icon> */}
            </Button>
          </div>
        </div>

        <Divider />
        <Suspense fallback={<div>Loading ....</div>}>
          {this.props.active_table === "mdo" && <MDOTable />}
          {this.props.active_table === "fse" && <FSETable />}
          {this.props.active_table === "backOffice" && (
            <BackOfficeEmpolyeeTable />
          )}
        </Suspense>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  active_table: state.selectedAdminTable.active_table,
});

const mapDispatchToProps = (dispatch) => ({
  changeTo: (table) => dispatch(changeTo(table)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserManagementSection)
);
